import React, { useState, useEffect, useContext, useCallback } from "react";
import SideMenuContext from "../context/sideMenuContext";
import CreateProjectForm from "./forms/createProjectForm";
import {
  getDynamicFieldsFromMenuForCreateNew,
  getProjectType,
} from "../services/uiService";
import { Button } from "react-bootstrap";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { createProjectThunk } from "./../redux/createproject/createProjectThunk.js";
import { lowercaseFirstLetter } from './../services/helper.jsx'; 
import ModalComponent from "./modal/modalComponent";

/*const formatStringToDate = (inputString) => {
  if (!inputString || isNaN(new Date(inputString).toLocaleString())) {
    return null;
  }
  const date = new Date(inputString).toLocaleString();
  return date.toISOString().split("T")[0];
};*/


const formatTimeToDate = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);

  // Get individual components
  const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0"); // Ensure two digits
  const minutes = String(date.getMinutes()).padStart(2, "0"); // Ensure two digits

  return `${date.toLocaleDateString("en-GB")}`;
};

const CreateProject = (props) => {
  const [fieldItems, setFieldItems] = useState([]);
  const [isProjectExists, setIsProjectExists] = useState(false);
  const [isProjectCreatedFailedModal, setIsCreatedFailedModal] =
    useState(false);
  const [projectIdFromResponse, setProjectIdFromResponse] = useState(null);

  const history = useHistory();
  const dispatch = useDispatch();
  const projectResult = useSelector((state) => state?.project?.NewProject);
  const transformData = (data) => {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        value !== "" ? value : null,
      ])
    );
  };

  const fetchMenuFieldsWithProjectOptions = async () => {
    try {
      const [fields, projectOptions] = await Promise.all([
        getDynamicFieldsFromMenuForCreateNew(props.generalEndPoint, 5),
        getProjectType(props.generalEndPoint),
      ]);

      const typeMapping = {
        Text: "text",
        Date: "date",
        Dropdown: "select",
        Number: "number",
        TextArea: "textarea",
      };

      const optionsField = projectOptions.map((option) => ({
        value: option.id,
        label: option.name,
      }));

      const updatedFields = fields.map((field) => ({
        name: field.id,
        label: field.title,
        type: typeMapping[field.typeName]?.toLowerCase() || "text",
        isDisabled: field.disabled,
        isRequired: !field.allowNull,
        options: field.typeName === "Dropdown" ? optionsField : [],
        sequence: field.index_,
      }));

      setFieldItems(updatedFields);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  function formatDateForInput(dateStr) {
    if (dateStr !== null)
    {
      const [day, month, year] = dateStr.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return null;
  }

  const onClickSubmitForm = useCallback(
    async (values, validateForm, setTouched, shouldRedirect, resetForm) => {
      setTouched(
        Object.keys(values).reduce((acc, key) => ({ ...acc, [key]: true }), {})
      );
      localStorage.setItem("routeActive", "singleproject-route");
      const errors = await validateForm();

      const userDataString = sessionStorage.getItem("userData");
      let displayName = "";

      if (userDataString) {
        const userData = JSON.parse(userDataString);
        displayName = userData.user.displayName;
        values["UpdatedBy"] = displayName
      }

      values["UpdatedDate"] = new Date();
      if (Object.keys(errors).length === 0) {
        try {
          const payload = transformData(values);
          // Include ProjectID if we have it from a previous successful creation
          if (projectIdFromResponse !== null) {
            payload.ProjectID = projectIdFromResponse;
          }
          const response = await dispatch(
            createProjectThunk({ endpoint: props.generalEndPoint, payload })
          );

          if (response?.payload?.succeeded === false) {
            setIsProjectExists(true);
            return;
          }

          // Extract ProjectID from response
          const projectData = response.payload?.project;
          if (projectData) {
            if (projectData.projectID) {
              setProjectIdFromResponse(projectData.projectID);
            }
          }

          const updatedFieldItems = fieldItems.map((item) => {
            let updatedItem = { ...item };

            if (item.type === "date") {
              //updatedItem.value = formatTimeToDate(response?.project?.[item?.name])
                if (((item?.name).toLowerCase() ==="creationdate" || (item?.name).toLowerCase() ==="updateddate") && response.payload.project?.[item?.name] === undefined)
                {
                  updatedItem.value = formatTimeToDate(response.payload.project?.[lowercaseFirstLetter(item?.name)]);                 
                }
                else {
                  updatedItem.value = formatTimeToDate(response.payload.project?.[item?.name]);
              }
            }
            else if (item.name === "ProjectNumber") {
                updatedItem.isDisabled = true
                updatedItem.value = response.payload.project?.[item?.name] || null
            }
            else {
              updatedItem.value = response.payload.project?.[item?.name] || null
            }

            return updatedItem;
          });

          setFieldItems(updatedFieldItems);
          if (projectResult?.message) {
            if (shouldRedirect) {
              sessionStorage.setItem("sessionID", "");
              history.push("/home/intake", {
                data: values,
                preData: projectResult?.project,
              });
            }
          }
        } catch (error) {
          setIsCreatedFailedModal(true);
          resetForm();
        }
      }
    },
    [fieldItems, projectIdFromResponse]
  );

  const onClickCloseForm = useCallback(
    (resetForm) => {
      resetForm();
      localStorage.clear();
      history.push("/home");
    },
    [fieldItems]
  );

  useEffect(() => {
    localStorage.removeItem("routeActive");
    fetchMenuFieldsWithProjectOptions();
  }, []);

  return (
    <>
      <SideMenuContext.Consumer>
        {({ isSelectedMenu }) => {
          return (
            <>
              {fieldItems.length > 0 && (
                <CreateProjectForm
                  fields={fieldItems}
                  onClickCloseForm={onClickCloseForm}
                  onClickSubmitForm={onClickSubmitForm}
                />
              )}
            </>
          );
        }}
      </SideMenuContext.Consumer>
      <ModalComponent
        show={isProjectExists}
        onHide={() => setIsProjectExists(false)}
        title=""
        bodyContent={<p>פרויקט עם מספר פרויקט זהה כבר שמור במערכת. אנא בחר מספר פרויקט אחר</p>}
        footerContent={
          <>
            <Button onClick={() => setIsProjectExists(false)}>סגירה</Button>
          </>
        }
      />
      <ModalComponent
        show={isProjectCreatedFailedModal}
        onHide={() => setIsCreatedFailedModal(false)}
        title=""
        bodyContent={<p>השמירה נכשלה</p>}
        footerContent={
          <>
            <Button onClick={() => setIsCreatedFailedModal(false)}>
              סגירה
            </Button>
          </>
        }
      />
    </>
  );
};

export default CreateProject;
